import { Box, ButtonProps, MenuItem, MenuList, Paper } from "@mui/material";
import { useRef } from "react";
import { XButton } from "./x-button";

export interface HoverMenuOption {
  id: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface HoverMenuButtonProps {
  options: ReadonlyArray<HoverMenuOption>;
  label: string;
  buttonProps?: ButtonProps;
}

export function HoverMenuButton({
  options,
  label,
  buttonProps,
}: HoverMenuButtonProps) {
  const rootRef = useRef<HTMLDivElement>(null);

  const closeMenu = () => {
    rootRef.current?.classList.remove("menu-open");
  };

  const openMenu = () => {
    rootRef.current?.classList.add("menu-open");
  };

  return (
    <Box
      ref={rootRef}
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
      sx={{
        position: "relative",
        display: "inline-block",

        "& .hover-menu": {
          opacity: 0,
          pointerEvents: "none",
          transform: "translateY(-4px)",
          transition: "opacity 120ms ease, transform 120ms ease",
        },

        "&.menu-open .hover-menu": {
          opacity: 1,
          pointerEvents: "auto",
          transform: "translateY(0)",
        },
      }}
    >
      <XButton {...buttonProps}>{label}</XButton>

      <Paper
        className="hover-menu"
        elevation={4}
        sx={{
          position: "absolute",
          top: "100%",
          left: 0,
          minWidth: 160,
          zIndex: 1300,
        }}
      >
        <MenuList dense>
          {options.map((opt) => (
            <MenuItem
              key={opt.id}
              disabled={opt.disabled}
              onClick={() => {
                opt.onClick();
                closeMenu();
              }}
            >
              {opt.label}
            </MenuItem>
          ))}
        </MenuList>
      </Paper>
    </Box>
  );
}
